module.exports = __webpack_public_path__ + "img/足部3D扫描.daef0b69.png";